import {DisplayType} from '../../../modules/users/models/DisplayType';
import {FilterObject} from '../../../shared/models/FilterBarObject';
import {AccessPointStatusSignalR} from '../../models/notification-payload';
import {User} from '../../models/user/user.interface';
import {UserFilter} from './users.model';

export class LoadUsers {
  static type = '[Users] Load Users';
}
export class LoadIdHoldersName {
  static type = '[Users] Load ID holders names';
}

export class LoadMoreUsersResults {
  static type = '[Users] Load More Users Results';

  constructor(public resetChunk: boolean = false) {
  }
}

export class SetIsLoadingData {
  static type = '[Users] Change isLoadingData';

  constructor(public isLoadingData: boolean = true) {
  }
}

export class SelectUser {
  static type = '[Users] Select User';

  constructor(public user: User) {
  }
}

export class ChangeUserViewType {
  static type = '[Users] Change User View Type';

  constructor(public displayType: DisplayType) {
  }
}

export class SetUsersFilter {
  static type = '[Users] Change Users Filter';

  constructor(public userFilter: FilterObject<UserFilter>) {
  }
}

export class GetUsersConfiguration {
  static type = '[Users] Get Users Configuration';
}

export class SaveOrModifyUser {
  static type = '[Users] Save  Or Modify User';

  constructor(public user: any, public saveUserCallback: (any,closeFormAfter)=> void, public closeFormAfter:boolean = true) {
  }
}

export class UpdateUserAccessPointsState {
  static type = '[Users] Update User Acess Point State';

  constructor(public payload: AccessPointStatusSignalR) {
  }
}
export class SaveUserPermissions {
  static type = '[Users] Save User Permissions';

  constructor(public permissions: any) {
  }
}
export class IsPinCodeAlreadyInUse {
  static type = '[Users] Check If Typed PinCode Is Already In Use';

  constructor(public user: any, public pinCode: string, public isPinCodeAlreadyInUseCallback: (any)=> boolean) {
  }
}
